var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUpRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M.942 1.386H9.5v8.558m0-8.558-9 9"
})));
export { SvgArrowUpRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDEwIDExIiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0wLjk0MTg5NSAxLjM4NjA1SDkuNDk5ODZMOS40OTk4NiA5Ljk0NDA0IiBzdHJva2U9IiMyRjY0RUQiIC8+CiAgICA8cGF0aCBkPSJNOS41IDEuMzg2MDVMMC41MDAwMjcgMTAuMzg2IiBzdHJva2U9IiMyRjY0RUQiIC8+Cjwvc3ZnPg==";